'use client';

import { Accordion } from '@/components/molecules';
import { useSeasonDistrictDivisionInfo } from '@/hooks/custom-hooks/useSeasonDistrictDivisionInfo';
import { useTeamLeagueInfo } from '@/hooks/custom-hooks/useTeamLeagueInfo';
import { formatTeamLeagueLabels } from '@/utils/helpers';

export const DistrictList = () => {
	const { districtsInfo } = useSeasonDistrictDivisionInfo();

	const teamLeagueInfo = useTeamLeagueInfo();
	const labels = formatTeamLeagueLabels(teamLeagueInfo);

	return (
		<div className="my-6 flex w-full flex-col gap-8 xl:mx-0">
			<h2 className="text-2xl font-semibold leading-8 text-darkorange-600">{labels.districtPluralTitle}</h2>

			<div className="flex flex-col gap-6">
				{districtsInfo.map((district) => (
					<Accordion
						key={district.uuid}
						districtName={district.title}
						numberOfDivisions={district.divisionsCount}
						districtImg={district?.logo?.url}
						divisions={district.divisions}
					/>
				))}
			</div>
		</div>
	);
};
